module.exports = {
  store: '店铺',
  salesOrderDate: '平台订单创建时间',
  returnRequestDate: '平台退货申请时间',
  returnCreateDate: 'OMS退货申请时间',
  rwReceiveDate: '退货物流签收时间',
  returnStatus: '退货单状态',
  refundStatus: '是否退款',
  grade: 'Grade',
  upc: '退回商品编码',
  downloadQueryTemplate: '下载查询模板',
  uploadQueryData: '上传查询条件',
  exportResults: '导出结果',
  tableTitle: '本列表展示前10条预览数据，更多明细请参考导出结果。',
  tableCol1: '平台退货编号',
  tableCol2: '退回快递单号',
  tableCol3: '平台退货申请时间',
  tableCol4: '绿通标签',
  interceptedText: '拦截或拒收',
  tableCol5: '退货单状态',
  tableCol6: '路由状态',
  tableCol7: '店铺信息',
  tableCol8: '平台订单编码',
  tableCol9: '退款单号',
  tableCol10: '是否退款',
  salesOrderNumber: '平台订单编码',
  returnOrderNumber: '平台退货编号',
  returnTrackingNumber: '退回快递单号',
  maxErrorTitle: '一次最多上传200行数据',
  placeholderFormat: '格式：\nXXXXXX\nXXXXXX',
  downloadCheckBox: '导出包含异常工单信息',
  loadingTip: '解析中...',
  downloadTip: '任务已创建，请前往下载任务中查看',
  dlpOrderRiskWarning: 'DLP订单风险预警',
  dlpUserLevel: 'DLP用户等级',
  warningType: '预警类型'
}
